import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import StaticResource from '@/views/StaticResource'
import PaymentMethods from '@/views/PaymentMethods'
import Grid from '@/views/Grid'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/v2/',
  routes: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/StaticResource',
      name: 'StaticResource',
      alias: ['/about', '/terms', '/privacy', '/contact'],
      component: StaticResource
    },
    {
      path: '/payment-methods',
      name: 'PaymentMethods',
      component: PaymentMethods
    },
    {
      path: '/grid',
      name: 'Grid',
      component: Grid
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js